import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Download } from 'lucide-react';

export function InstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handleShow = () => setShowPrompt(true);
    const handleHide = () => setShowPrompt(false);

    window.addEventListener('show-install-prompt', handleShow);
    window.addEventListener('hide-install-prompt', handleHide);

    return () => {
      window.removeEventListener('show-install-prompt', handleShow);
      window.removeEventListener('hide-install-prompt', handleHide);
    };
  }, []);

  if (!showPrompt) return null;

  const handleInstall = () => {
    (window as any).showInstallPrompt?.();
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    (window as any).dismissInstallPrompt?.();
    setShowPrompt(false);
  };

  return (
    <div 
      className="fixed bottom-4 left-4 right-4 z-50 bg-card border border-card-border rounded-lg shadow-lg p-4 flex items-center gap-3"
      data-testid="install-prompt-banner"
    >
      <Download className="w-6 h-6 text-primary flex-shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-card-foreground">Als App installieren</p>
        <p className="text-sm text-muted-foreground">
          Schneller Zugriff direkt vom Homescreen
        </p>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="default" 
          size="sm"
          onClick={handleInstall}
          data-testid="button-install-app"
        >
          Installieren
        </Button>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={handleDismiss}
          data-testid="button-dismiss-install"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
